import React from "react";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import "../../Resume/ResumeTab.scss";

const ResumeTabPreview = ({ interview }) => {
  const { t } = useTranslation();

  const resumeSummary = interview?.resumeSummary?.resume || "";

  return (
    <div className="resume-tab">
      <div className="row">
        <div className="col-12">
          {resumeSummary ? (
            <div
              className="markdown-content two-column-layout"
              style={{
                backgroundColor: "white",
                background: "white",
                color: "#374151",
                position: "relative",
                padding: "2rem",
                border: "none",
                borderRadius: "12px"
              }}
            >
              <ReactMarkdown
                skipHtml={false}
                components={{
                  // Force light theme on all elements
                  div: ({ children, ...props }) => (
                    <div
                      {...props}
                      style={{
                        backgroundColor: "transparent",
                        color: "#374151"
                      }}
                    >
                      {children}
                    </div>
                  ),
                  p: ({ children, ...props }) => (
                    <p
                      {...props}
                      style={{
                        color: "#374151",
                        backgroundColor: "transparent"
                      }}
                    >
                      {children}
                    </p>
                  ),
                  h1: ({ children, ...props }) => (
                    <h1
                      {...props}
                      style={{
                        color: "#1f2937",
                        backgroundColor: "transparent"
                      }}
                    >
                      {children}
                    </h1>
                  ),
                  h2: ({ children, ...props }) => (
                    <h2
                      {...props}
                      style={{
                        color: "#374151",
                        backgroundColor: "transparent",
                        borderLeft: "none",
                        paddingLeft: "0",
                        position: "relative"
                      }}
                    >
                      {children}
                    </h2>
                  ),
                  h3: ({ children, ...props }) => (
                    <h3
                      {...props}
                      style={{
                        color: "#4b5563",
                        backgroundColor: "transparent"
                      }}
                    >
                      {children}
                    </h3>
                  ),
                  li: ({ children, ...props }) => (
                    <li
                      {...props}
                      style={{
                        color: "#374151",
                        backgroundColor: "rgba(59, 130, 246, 0.05)"
                      }}
                    >
                      {children}
                    </li>
                  ),
                  strong: ({ children, ...props }) => (
                    <strong
                      {...props}
                      style={{
                        color: "#1f2937",
                        backgroundColor: "transparent"
                      }}
                    >
                      {children}
                    </strong>
                  )
                }}
              >
                {resumeSummary}
              </ReactMarkdown>
            </div>
          ) : (
            <div className="no-content">
              <p className="text-muted">{t("No resume summary available")}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResumeTabPreview;
